import ApiService from './api';

class AuthService extends ApiService {
  constructor() {
    super('/auth');
  }

  async login(credentials) {
    return await this.create(credentials, '/login');
  }

  async forgotPassword(email) {
    return await this.create({ email }, '/forgot-password');
  }

  async resetPassword(email, code, newPassword) {
    return await this.create(
      { email, code, newPassword },
      '/reset-password'
    );
  }

  async me() {
    return await this.get('/me');
  }
}

export default new AuthService();

